import * as React from 'react';

import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useCompany } from '../../contexts/Company';
import { useAuth } from '../../contexts/auth';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
        width: '395px',
        height: '290px'
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function Video({ videoUrl ,openVideo, setOpenVideo, videoEnded, setVideoEnded, session, activity, setCongratulations }) {
    const { code: companyCode } = useCompany() 
    const { user } = useAuth()

    const handleClose = () => {
        setOpenVideo(false);
    };

    const getVideoId = (url) => {
        const regex = /(?:youtube\.com\/(?:embed\/|watch\?v=|v\/|ytscreeningroom\?v=|embed\/|v=|ytscreeningroom\?v=|youtu\.be\/|watch\?.+&v=)|youtu\.be\/|embed\/|v\/|ytscreeningroom\?v=|youtu\.be\/|watch\?.+&v=)([^#\&\?]*).*/;
        const match = url.match(regex);
        if (match && match[1]) {
          return match[1];
        } else {
          return null;
        }
      };

    const videoId = getVideoId(videoUrl);

    return (
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={openVideo}
        >
            <DialogContent dividers>
                <iframe
                    src={`https://www.youtube.com/embed/${videoId}`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '290px' }}
                ></iframe>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleClose}>
                    Cerrar
                </Button>
            </DialogActions>
        </BootstrapDialog>



    );
}